if (!customElements.get('custom-price')) {
    class CustomPrice extends HTMLElement {
        constructor() {
            super();
            this.taxRules = [];
        }

        connectedCallback() {
            this.init();
        }

        async init() {
            this.taxRules = await window.CustomTaxRules.getTaxRules(this.getAttribute('data-country-code'));
            this.updatePrice();
        }

        updatePrice() {
            // Get the value from the data-value attribute
            const rawValue = this.getAttribute('data-value');
            let price = rawValue ? Number(rawValue) : null;

            if (price !== null && !isNaN(price)) {
                // Get vat type
                const vatType = this.getAttribute('data-vat');

                if (this.taxRules && this.taxRules.length > 0 && vatType && this.getAttribute('data-tax-exempt') !== 'true') {
                    const rule = this.taxRules.find(r => r.collection === vatType);
                    if (rule) {
                        if (typeof rule.rate !== 'undefined') {
                            const rate = Number(rule.rate);
                            if (!isNaN(rate)) {
                                price = price * (1 + rate / 100);
                            }
                        }
                    }
                }

                price = window.CustomNumberFormatters.formatPrice(price / 100);

                const strikedThrough = this.getAttribute('data-striked-through');
                if (strikedThrough) {
                    this.innerHTML = `<s>${price}</s>`;
                } else {
                    this.textContent = price;
                }
            } else {
                this.textContent = '';
            }
        }
    }

    customElements.define(
        'custom-price',
        CustomPrice,
    )
}